import { Component, HostBinding, Input } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

@Component({
    selector: 'app-icon-button',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.scss'],
    standalone: false
})
export class IconButtonComponent {
    @HostBinding('attr.role') public roleAttribute = 'button';
    @HostBinding('attr.tabindex') public tabIndex = 0;
    @HostBinding('attr.disabled') @Input() public disabled = '';

    @Input()
    public icon: IconDefinition;

    // TODO Remove LiteralSize och RelativeSize, once the missing size options have been added in the SizeProp type
    // https://github.com/FortAwesome/angular-fontawesome/issues/355
    @Input()
    public size: LiteralSize | RelativeSize | SizeProp;

    @Input()
    public bigIcon: boolean;
}
